import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../../index';
import { HistoryState } from '../../slices/history';

export const selectInstanceHistory = (): any =>
    createSelector(
        (state: RootState) => state.history,
        (state: HistoryState) => state.instanceHistory,
    );
